{
    "InboundcallsHeader": "Inbound Calls",
    "InboundcallsAvgordervalueLabel": "Average Order Value:",
    "InboundcallsStrikerateLabel": "Strike Rate (Calls Per Order):",
    "OutboundcallsHeader": "Outbound Calls",
    "OutboundcallsAvgordervalueLabel": "Average Order Value:",
    "OutboundcallsStrikerateLabel": "Strike Rate (Calls Per Order):",
    "NAME": "MonetaryCallAssignments",
    "MonetaryCallAssignments_SectionHeader": "Monetary Call Assignments",
    "MonetaryCallAssignments_SectionPara": "You can control how financial/monetary call statistics are calculated by assigning estimated sales order or monetary values to successful inbound & outbound calls, as well as specifying a call strike rate as the number of calls per sale/order."
}